import { Autocomplete, Box, TextField } from '@mui/material';

import { StyledCampaignFormRow } from '~/entities/Campaign/components';
import { SegmentFromListCampaign } from '~/types';

import { SelectSubcategory } from './Selects/SelectSubcategory';

interface SubcategorySelectionProps {
  category: { id: string; name: string };
  onSubcategoryChange: (value: { id: string; name: string }[]) => void;
  segments: SegmentFromListCampaign[];
}

export const SubcategorySelection = ({
  category,
  onSubcategoryChange,
  segments,
}: SubcategorySelectionProps) => {
  const segmentField = segments.find(
    segment => segment.segmentType?.name === 'Categorias'
  );

  if (!segmentField) return null;

  const selectedSubcategories =
    segmentField.segmentSelections?.find(
      selection => selection.id === category.id
    )?.subcategorias ?? [];

  return (
    <Box key={`box-${category.id}`}>
      <StyledCampaignFormRow key={`segment-row-${category.id}`}>
        <Autocomplete
          sx={{ flexGrow: 1, flexBasis: '30%' }}
          options={[]}
          disabled
          value={category}
          isOptionEqualToValue={(option, value) => option.name === value.name}
          getOptionLabel={option => option.name}
          renderInput={params => (
            <TextField {...params} variant="filled" label="Categoria" />
          )}
        />

        <SelectSubcategory
          key="select"
          id={`select-subcategory-${segmentField.id}`}
          label="Subcategoria"
          onChange={onSubcategoryChange}
          value={selectedSubcategories}
          idCategoria={category.id}
        />
      </StyledCampaignFormRow>
    </Box>
  );
};
